module.exports = __webpack_public_path__ + "media/laughing_man.a4c6a65e.mp3";